// Recognises a Turbo request that never reached the server — the device dropped
// its connection mid-navigation (a phone on a building site losing signal).
//
// Turbo already handles this for the user: a Visit records it as a network
// failure and falls back to a full page load, a frame resolves its visit. But
// `FetchRequest#perform` rethrows the error after delegating it, and nothing up
// the chain awaits that promise, so every dropped connection surfaces as an
// unhandled rejection:
//
//   TypeError: Failed to fetch
//       at fetchWithTurboHeaders (application-….js)
//       at FetchRequest.perform (application-….js)
//
// Chrome's wording, "Failed to fetch", is also what our own `fetch()` calls get
// on a CORS or offline failure — and an uncaught one there IS ours to fix. So the
// message alone does not decide it: only the stack running through Turbo's own
// request does. (Safari's "Load failed" and Firefox's "NetworkError when
// attempting to fetch resource" are already ignored outright in honeybadger.js.)

const NETWORK_FAILURE_MESSAGE = "Failed to fetch"

const TURBO_REQUEST_METHOD = /(^|\.)(fetchWithTurboHeaders|FetchRequest\.perform)$/

// `message` and `backtrace` as Honeybadger hands them to a beforeNotify handler.
export const turboNetworkFailure = (message, backtrace) => {
  if (!(message || "").includes(NETWORK_FAILURE_MESSAGE) || !Array.isArray(backtrace)) {
    return false
  }

  return backtrace.some((frame) => TURBO_REQUEST_METHOD.test((frame && frame.method) || ""))
}
